import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { TOAST } from 'constant';
import { toast } from 'layout';
import { mapError } from 'utils/func';

export default function ConfirmSubmit({
  visible,
  setVisible,
  councilMemberId,
  councilId,
  projectProposalId,
  submitReview,
  refetch,
  refetchCouncil,
  setIsFormModalOpen,
}) {
  // #region Data
  const { t } = useTranslation();

  const { mutate } = useMutation(submitReview);
  // #endregion

  // #region Event
  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('employee.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('employee.ok')}
        className="w-7rem"
        severity="info"
        onClick={() => {
          mutate(
            {
              councilMemberId,
              councilId,
              projectProposalId,
            },
            {
              onSuccess: () => {
                toast(TOAST.SUCCESS, t('council.review.submitSuccess'));
                setVisible(false);
                refetch();
                refetchCouncil();
                setIsFormModalOpen(false);
              },
              onError: (error) => {
                toast(TOAST.ERROR, mapError(t, error));
              },
            }
          );
        }}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={<p className="text-red-500">{t('council.review.confirmSubmitTitle')}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg">{t('council.review.confirmSubmitMessage')}</p>
    </Dialog>
  );
}

ConfirmSubmit.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  councilMemberId: PropTypes.string.isRequired,
  councilId: PropTypes.string.isRequired,
  projectProposalId: PropTypes.string.isRequired,
  submitReview: PropTypes.func.isRequired,
  refetch: PropTypes.func.isRequired,
  refetchCouncil: PropTypes.func.isRequired,
  setIsFormModalOpen: PropTypes.func.isRequired,
};
